function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { Box, Text, Link } from "@thebouqs/layout";
import { useMultiStyleConfig } from "@thebouqs/system";
export var Ribbon = _ref => {
  var {
    html = "",
    link = "",
    color = "",
    backgroundColor = "",
    linkText = "",
    testid = "",
    jsxElement = null,
    asLink: RouterLink = null,
    onClickFn = () => {}
  } = _ref;
  var styles = useMultiStyleConfig("Ribbon", {});
  var fontSizesArr = ["sm", "sm", "lg", "lg"];

  var createMarkup = () => {
    return {
      __html: html
    };
  };

  var ribbonContent = () => {
    if (linkText.length) {
      return /*#__PURE__*/React.createElement(Text, {
        sx: styles.link
      }, linkText);
    }

    if (html.length) {
      return /*#__PURE__*/React.createElement(Box, {
        sx: styles.link,
        dangerouslySetInnerHTML: createMarkup()
      });
    }

    return /*#__PURE__*/React.createElement(Box, {
      as: "span",
      sx: _extends({}, styles.link)
    }, jsxElement);
  };

  var parseUrl = link => {
    var urlOfPassedLink = new URL(link);
    var pathOfLink = urlOfPassedLink.pathname;
    return (pathOfLink == null ? void 0 : pathOfLink.length) > 1 ? pathOfLink : link;
  };

  var conditionalLinkProps = () => {
    var optionalPropsObj = {};
    optionalPropsObj["href"] = link;

    if (RouterLink) {
      optionalPropsObj["as"] = RouterLink;
      optionalPropsObj["to"] = parseUrl(link);
    } else {
      optionalPropsObj["as"] = "a";
    }

    return optionalPropsObj;
  };

  var _internalRibbonOnClick = () => {
    onClickFn();
    return true;
  };

  return /*#__PURE__*/React.createElement(Link, _extends({
    sx: styles.container,
    display: "flex",
    color: color,
    backgroundColor: backgroundColor,
    fontSize: fontSizesArr,
    "data-testid": "ribbon-" + (testid.length ? testid : linkText),
    onClick: _internalRibbonOnClick,
    _hover: {
      textDecoration: "none"
    }
  }, conditionalLinkProps()), ribbonContent());
};
//# sourceMappingURL=Ribbon.js.map